module.exports = __webpack_public_path__ + "static/media/Diamond (1).42a13912.svg";